import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

Vue.config.productionTip = false

const turkishMoney = function (value) {
  if (value == "" || value == null) {
    return value;
  } else {
    value = new Intl.NumberFormat('tr-TR', {currency: 'TRY', minimumFractionDigits: 2, maximumFractionDigits:2 }).format(value)+"₺";
    return value;
  }
};

Vue.filter('turkishMoney', turkishMoney);


new Vue({
  render: h => h(App),
}).$mount('#app')
